export const sets = {};
sets.global = "global";
sets.inputFocused = "inputFocused";
sets.rightCursorHoveringOnPen = "rightCursorHoveringOnPen";
sets.rightCursorHoveringOnCamera = "rightCursorHoveringOnCamera";
sets.rightCursorHoveringOnInteractable = "rightCursorHoveringOnInteractable";
sets.rightCursorHoveringOnUI = "rightCursorHoveringOnUI";
sets.rightCursorHoveringOnVideo = "rightCursorHoveringOnVideo";
sets.rightCursorHoveringOnNothing = "rightCursorHoveringOnNothing";
sets.rightCursorHoldingPen = "rightCursorHoldingPen";
sets.rightCursorHoldingCamera = "rightCursorHoldingCamera";
sets.rightCursorHoldingInteractable = "rightCursorHoldingInteractable";
sets.rightCursorHoldingUI = "rightCursorHoldingUI";
sets.rightCursorHoldingNothing = "rightCursorHoldingNothing";
sets.leftCursorHoveringOnPen = "leftCursorHoveringOnPen";
sets.leftCursorHoveringOnCamera = "leftCursorHoveringOnCamera";
sets.leftCursorHoveringOnInteractable = "leftCursorHoveringOnInteractable";
sets.leftCursorHoveringOnUI = "leftCursorHoveringOnUI";
sets.leftCursorHoveringOnVideo = "leftCursorHoveringOnVideo";
sets.leftCursorHoveringOnNothing = "leftCursorHoveringOnNothing";
sets.leftCursorHoldingPen = "leftCursorHoldingPen";
sets.leftCursorHoldingCamera = "leftCursorHoldingCamera";
sets.leftCursorHoldingInteractable = "leftCursorHoldingInteractable";
sets.leftCursorHoldingUI = "leftCursorHoldingUI";
sets.leftCursorHoldingNothing = "leftCursorHoldingNothing";
sets.rightHandHoveringOnUI = "rightHandHoveringOnUI";
sets.rightHandTeleporting = "rightHandTeleporting";
sets.rightHandHoveringOnPen = "rightHandHoveringOnPen";
sets.rightHandHoveringOnCamera = "rightHandHoveringOnCamera";
sets.rightHandHoveringOnInteractable = "rightHandHoveringOnInteractable";
sets.rightHandHoveringOnNothing = "rightHandHoveringOnNothing";
sets.rightHandHoldingPen = "rightHandHoldingPen";
sets.rightHandHoldingCamera = "rightHandHoldingCamera";
sets.rightHandHoldingInteractable = "rightHandHoldingInteractable";
sets.leftHandHoveringOnUI = "leftHandHoveringOnUI";
sets.leftHandTeleporting = "leftHandTeleporting";
sets.leftHandHoveringOnPen = "leftHandHoveringOnPen";
sets.leftHandHoveringOnCamera = "leftHandHoveringOnCamera";
sets.leftHandHoveringOnInteractable = "leftHandHoveringOnInteractable";
sets.leftHandHoldingPen = "leftHandHoldingPen";
sets.leftHandHoldingCamera = "leftHandHoldingCamera";
sets.leftHandHoldingInteractable = "leftHandHoldingInteractable";
sets.leftHandHoveringOnNothing = "leftHandHoveringOnNothing";
sets.debugUserInput = "debugUserInput";
sets.inspecting = "inspecting";
